function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M156 237C242.156 237 312 221.216 312 201.747C312 182.277 242.156 166.494 156 166.494C69.8436 166.494 0 182.277 0 201.747C0 221.216 69.8436 237 156 237Z",
  fill: "#F1F1F1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M198.152 102.8C192.31 71.2552 173.227 63.0905 176.343 35.9987C177.001 30.2723 181.016 17.8138 177.901 5.93793C163.88 23.7517 123.766 22.2672 106.63 0C100.01 15.9582 102.736 22.2672 105.072 32.6586C111.21 59.9546 89.1048 68.2862 81.7051 109.481C76.8884 136.296 81.7051 159.231 87.1037 176.645C107.161 216.57 175.068 209.774 187.835 182.167C199.424 157.108 204.67 137.995 198.152 102.8Z",
  fill: "#D9D4CC"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M136.237 46.0171C139.376 45.4001 142.634 45.329 146.048 46.0171C144.871 52.7486 136.629 51.2528 136.237 46.0171Z",
  fill: "#2C4756"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M150.049 46.9421L168.066 44.4291C168.227 44.4104 168.345 44.2682 168.321 44.1111C168.302 43.9578 168.153 43.8457 167.988 43.8681L149.9 45.8427C149.582 45.8838 149.358 46.1605 149.398 46.4634C149.441 46.7664 149.731 46.9795 150.049 46.9421Z",
  fill: "#9BA5AA"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M149.936 48.5786L172.321 49.665C172.485 49.6766 172.628 49.5584 172.64 49.4017C172.648 49.2447 172.524 49.1091 172.359 49.1012L150.011 47.4733C149.689 47.4545 149.413 47.6842 149.393 47.9905C149.374 48.293 149.615 48.5561 149.936 48.5786Z",
  fill: "#9BA5AA"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M149.014 50.2808L166.366 55.2577C166.522 55.3081 166.691 55.2261 166.74 55.076C166.789 54.9259 166.703 54.7654 166.549 54.7196L149.366 49.2281C149.06 49.1328 148.732 49.2949 148.637 49.5843C148.54 49.8773 148.707 50.1891 149.014 50.2808Z",
  fill: "#9BA5AA"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M132.408 46.0302L114.32 44.0556C114.155 44.0332 114.006 44.1453 113.986 44.2986C113.963 44.4557 114.081 44.5979 114.241 44.6166L132.258 47.1296C132.576 47.167 132.867 46.9539 132.91 46.6509C132.949 46.348 132.726 46.0713 132.408 46.0302Z",
  fill: "#9BA5AA"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M132.303 47.6608L109.954 49.2887C109.79 49.2966 109.665 49.4322 109.674 49.5892C109.686 49.7459 109.828 49.8641 109.993 49.8525L132.378 48.7661C132.699 48.7436 132.94 48.4805 132.92 48.178C132.901 47.8717 132.624 47.642 132.303 47.6608Z",
  fill: "#9BA5AA"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M132.926 49.4175L115.744 54.9091C115.59 54.9549 115.504 55.1153 115.553 55.2655C115.602 55.4156 115.77 55.4975 115.927 55.4471L133.278 50.4702C133.586 50.3785 133.752 50.0668 133.656 49.7738C133.561 49.4844 133.233 49.3222 132.926 49.4175Z",
  fill: "#9BA5AA"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M140.563 50.5552C140.705 51.8566 140.25 53.2777 139.155 54.3099C138.236 55.1775 136.879 55.7721 135.061 55.8245C134.897 55.8245 134.763 55.9517 134.763 56.1087C134.763 56.2658 134.897 56.393 135.061 56.393C137.106 56.449 138.66 55.8432 139.759 54.927C141.16 53.7527 141.796 52.0548 141.725 50.4767C141.702 50.1738 141.423 49.942 141.101 49.9644C140.783 49.9868 140.544 50.2523 140.563 50.5552Z",
  fill: "#2C4756"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M147.923 35.9349C149.118 35.2902 150.666 35.1183 152.097 35.6608C153.3 36.115 154.415 37.0622 155.194 38.6277C155.26 38.7716 155.435 38.8371 155.586 38.7742C155.737 38.7113 155.806 38.5439 155.74 38.4C154.975 36.5923 153.77 35.4782 152.449 34.8858C150.758 34.133 148.871 34.2579 147.382 34.9518C147.1 35.0937 146.989 35.4301 147.139 35.7021C147.288 35.9707 147.639 36.0734 147.923 35.9349Z",
  fill: "#2C4756"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M134.361 36.1322C133.291 35.4277 131.834 35.1691 130.411 35.6219C129.216 36.0007 128.051 36.8708 127.14 38.37C127.062 38.5081 126.887 38.5626 126.75 38.4919C126.613 38.4211 126.565 38.2521 126.644 38.114C127.568 36.3752 128.837 35.3457 130.16 34.8374C131.852 34.1921 133.638 34.4238 134.982 35.1937C135.236 35.3499 135.305 35.6881 135.132 35.9477C134.961 36.204 134.616 36.2851 134.361 36.1322Z",
  fill: "#2C4756"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M133.092 41.1396C135.004 40.6514 136.139 38.7787 135.626 36.9568C135.114 35.1349 133.149 34.0537 131.237 34.5418C129.325 35.03 128.19 36.9027 128.703 38.7247C129.215 40.5466 131.18 41.6278 133.092 41.1396Z",
  fill: "#2C4756"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M149.494 41.0969C151.406 41.5851 153.372 40.5039 153.884 38.682C154.396 36.8601 153.262 34.9873 151.35 34.4992C149.438 34.011 147.472 35.0922 146.96 36.9141C146.448 38.736 147.582 40.6087 149.494 41.0969Z",
  fill: "#2C4756"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M140.758 50.4767C140.687 52.0548 141.323 53.7527 142.724 54.927C143.823 55.8432 145.377 56.449 147.421 56.393C147.586 56.393 147.72 56.2658 147.72 56.1087C147.72 55.9517 147.586 55.8245 147.421 55.8245C145.604 55.7721 144.247 55.1775 143.328 54.3099C142.233 53.2777 141.778 51.8566 141.92 50.5552C141.939 50.2523 141.7 49.9868 141.382 49.9644C141.06 49.942 140.781 50.1738 140.758 50.4767Z",
  fill: "#2C4756"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M89.43 179.522C59.1967 164.464 52.2526 135.302 57.5608 96.5249C58.3775 90.5592 64.6505 90.92 63.7992 96.3885C59.5519 123.671 65.2808 157.924 89.1028 165.934L89.43 179.522Z",
  fill: "#D9D4CC"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M194.003 215.763C213.385 215.763 229.097 211.579 229.097 206.419C229.097 204.506 225.87 194.102 225.87 194.102L194.003 197.075L161.33 194.102C161.33 194.102 158.909 204.861 158.909 206.419C158.909 211.579 174.621 215.763 194.003 215.763Z",
  fill: "#6DA7C0"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M193.6 202.171C211.422 202.171 225.87 198.558 225.87 194.101C225.87 189.644 211.422 186.031 193.6 186.031C175.777 186.031 161.33 189.644 161.33 194.101C161.33 198.558 175.777 202.171 193.6 202.171Z",
  fill: "#79BEDC"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M193.6 198.772C208.303 198.772 220.223 196.68 220.223 194.1C220.223 191.519 208.303 189.428 193.6 189.428C178.896 189.428 166.977 191.519 166.977 194.1C166.977 196.68 178.896 198.772 193.6 198.772Z",
  fill: "#608899"
});

var SvgSmellyCat = function SvgSmellyCat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 237,
    viewBox: "0 0 312 237",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmellyCat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SmellyCat.db0a14c6.svg";
export { ForwardRef as ReactComponent };